/* eslint-disable import/prefer-default-export */

import isElectron from 'is-electron'

export const getAppVersions = includeAgentAutoUpdate => {
  let appVersion = { web: window.app_version }
  if (isElectron()) {
    const { echope, echopeAgent, echopeAgentAutoUpdate } = window.electronAPP.versions()
    if (includeAgentAutoUpdate === true) {
      appVersion = { app: echope, agent: echopeAgent, agentAutoUpdate: echopeAgentAutoUpdate }
    } else {
      appVersion = { app: echope, agent: echopeAgent }
    }

  }

  return appVersion
}
